var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/news"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.187 21H4.905C3.853 21 3 20.105 3 19V5c0-1.105.853-2 1.905-2h9.003c1.263 0 2.287 1.075 2.287 2.4v13.093c0 1.326.73 2.507 1.992 2.507Zm0 0h1.908C21.147 21 22 20.105 22 19v-.4c0-1.105-.853-2-1.905-2H18.91m-3.3-12.8h.965c1.052 0 1.905.895 1.905 2v12.8c0 1.206.848 2.204 1.952 2.374M6.43 14.5h6.335M6.43 17.3h4.049m-4.05-6.8v-4l4.05 4v-4",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.e9f79dd3792616daac2f6300ecca1f95.svg";
export { ForwardRef as ReactComponent };